document.addEventListener("DOMContentLoaded", function () {
    const mqMobile = window.matchMedia("(max-width: 991.98px)");
    const navbarSideCollapse = document.querySelector("#navbarSideCollapse");
    const offcanvasCollapse = document.querySelector(".offcanvas-collapse");
    const navbarMenuClose = document.querySelector("#navbarMenuClose");
    const backdrop = document.querySelector("#mobileNavBackdrop");

    function getFocusableElements(container) {
        if (!container) return [];
        const sel =
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.from(container.querySelectorAll(sel)).filter((el) => {
            if (el.closest("[hidden], [inert]")) return false;
            return el.getClientRects().length > 0;
        });
    }

    function trapFocusInContainer(container, e) {
        if (e.key !== "Tab" || !container) return;
        const focusables = getFocusableElements(container);
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (e.shiftKey) {
            if (active === first) {
                e.preventDefault();
                last.focus();
            }
        } else {
            if (active === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }

    function focusMenuCloseButton() {
        if (!navbarMenuClose) return;
        const focusClose = () => navbarMenuClose.focus({ preventScroll: true });
        requestAnimationFrame(() => {
            requestAnimationFrame(focusClose);
        });
    }

    function syncDialogAttributes() {
        if (!offcanvasCollapse) return;
        if (mqMobile.matches) {
            offcanvasCollapse.setAttribute("role", "dialog");
            offcanvasCollapse.setAttribute("aria-modal", "true");
            offcanvasCollapse.setAttribute("aria-labelledby", "mobileNavDialogTitle");
            const isOpen = offcanvasCollapse.classList.contains("open");
            offcanvasCollapse.setAttribute("aria-hidden", isOpen ? "false" : "true");
        } else {
            offcanvasCollapse.removeAttribute("role");
            offcanvasCollapse.removeAttribute("aria-modal");
            offcanvasCollapse.removeAttribute("aria-labelledby");
            offcanvasCollapse.removeAttribute("aria-hidden");
        }
    }

    function openMenu() {
        if (!mqMobile.matches || !offcanvasCollapse) return;
        offcanvasCollapse.classList.add("open");
        if (navbarSideCollapse) {
            navbarSideCollapse.classList.add("open");
            navbarSideCollapse.setAttribute("aria-expanded", "true");
        }
        document.body.classList.add("mobile-nav-open");
        document.body.style.overflow = "hidden";
        offcanvasCollapse.setAttribute("aria-hidden", "false");
        if (backdrop) {
            backdrop.removeAttribute("hidden");
            backdrop.setAttribute("aria-hidden", "false");
        }
        syncDialogAttributes();
        focusMenuCloseButton();
        if (offcanvasCollapse) {
            const onMenuOpenTransitionEnd = (e) => {
                if (e.target !== offcanvasCollapse || e.propertyName !== "transform") return;
                if (!offcanvasCollapse.classList.contains("open")) return;
                if (document.activeElement === navbarSideCollapse) {
                    focusMenuCloseButton();
                }
                offcanvasCollapse.removeEventListener("transitionend", onMenuOpenTransitionEnd);
            };
            offcanvasCollapse.addEventListener("transitionend", onMenuOpenTransitionEnd);
        }
    }

    function closeMenu() {
        if (!offcanvasCollapse || !offcanvasCollapse.classList.contains("open")) return;
        offcanvasCollapse.classList.remove("open");
        if (navbarSideCollapse) {
            navbarSideCollapse.classList.remove("open");
            navbarSideCollapse.setAttribute("aria-expanded", "false");
        }
        document.body.classList.remove("mobile-nav-open");
        document.body.style.overflow = "";
        offcanvasCollapse.setAttribute("aria-hidden", "true");
        if (backdrop) {
            backdrop.setAttribute("hidden", "");
            backdrop.setAttribute("aria-hidden", "true");
        }
        syncDialogAttributes();
        navbarSideCollapse?.focus();
    }

    syncDialogAttributes();
    mqMobile.addEventListener("change", (e) => {
        if (!e.matches && offcanvasCollapse?.classList.contains("open")) {
            closeMenu();
        }
        syncDialogAttributes();
    });

    if (navbarSideCollapse && offcanvasCollapse) {
        navbarSideCollapse.addEventListener("click", function (e) {
            if (!mqMobile.matches) return;
            e.preventDefault();
            if (offcanvasCollapse.classList.contains("open")) {
                closeMenu();
            } else {
                openMenu();
            }
        });
    }

    if (navbarMenuClose) {
        navbarMenuClose.addEventListener("click", function () {
            closeMenu();
        });
    }

    if (backdrop) {
        backdrop.addEventListener("click", function () {
            if (mqMobile.matches) closeMenu();
        });
    }

    document.addEventListener("keydown", function (e) {
        if (!offcanvasCollapse || !offcanvasCollapse.classList.contains("open") || !mqMobile.matches) {
            return;
        }
        if (e.key === "Escape") {
            e.preventDefault();
            closeMenu();
            return;
        }
        trapFocusInContainer(offcanvasCollapse, e);
    });

    const dropdownToggles = document.querySelectorAll(
        ".nav-item.dropdown .dropdown-toggle, .nav-item.has-megamenu .dropdown-toggle"
    );

    let isTouchDevice = false;

    // Detect touch support (sets flag on first touch)
    window.addEventListener("touchstart", function onFirstTouch() {
        isTouchDevice = true;
        window.removeEventListener("touchstart", onFirstTouch, false);
    }, false);

    dropdownToggles.forEach((toggle) => {
        const dropdownItem = toggle.closest(".nav-item");
        const dropdownMenu = dropdownItem.querySelector(".dropdown-menu");

        toggle.setAttribute("aria-expanded", "false");

        /** ---------------------------
            *  KEYBOARD ACCESSIBILITY
            * --------------------------- */
        toggle.addEventListener("keydown", (e) => {
            const isExpanded = toggle.getAttribute("aria-expanded") === "true";

            if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                e.preventDefault();
                toggle.setAttribute("data-menu-key-toggle", "1");
                toggleDropdown(toggle, dropdownItem, dropdownMenu);
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => toggle.removeAttribute("data-menu-key-toggle"));
                });
                return;
            }

            switch (e.key) {
                case "Escape":
                    if (isExpanded) {
                        e.preventDefault();
                        e.stopPropagation();
                        closeDropdown(toggle, dropdownItem, dropdownMenu);
                        toggle.focus();
                    }
                    break;

                case "ArrowDown":
                    e.preventDefault();
                    if (!isExpanded) openDropdown(toggle, dropdownItem, dropdownMenu);
                    const firstLink = dropdownMenu?.querySelector("a.subnav-link");
                    if (firstLink) firstLink.focus();
                    break;

                case "ArrowUp":
                    if (isExpanded) {
                        e.preventDefault();
                        const links = dropdownMenu?.querySelectorAll("a.subnav-link");
                        if (links?.length) links[links.length - 1].focus();
                    }
                    break;
            }
        });

        /** ---------------------------
            *  TOUCH & CLICK INTERACTIONS
            * --------------------------- */
        toggle.addEventListener("click", (e) => {
            if (toggle.getAttribute("data-menu-key-toggle") === "1") {
                toggle.removeAttribute("data-menu-key-toggle");
                return;
            }
            if (isTouchDevice) {
                e.preventDefault();
                e.stopPropagation();
            }
            toggleDropdown(toggle, dropdownItem, dropdownMenu);
        });

        toggle.addEventListener("touchend", (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown(toggle, dropdownItem, dropdownMenu);
        });

        /** ---------------------------
            *  HOVER (MOUSE ONLY)
            * --------------------------- */
        if (!isTouchDevice) {
            dropdownItem.addEventListener("mouseenter", () => {
                openDropdown(toggle, dropdownItem, dropdownMenu);
            });

            dropdownItem.addEventListener("mouseleave", () => {
                closeDropdown(toggle, dropdownItem, dropdownMenu);
            });
        }

        /** ---------------------------
            *  MENU KEYBOARD NAVIGATION
            * --------------------------- */
        if (dropdownMenu) {
            const menuLinks = dropdownMenu.querySelectorAll("a.subnav-link");

            menuLinks.forEach((link, index) => {
                link.addEventListener("keydown", (e) => {
                    switch (e.key) {
                        case "Escape":
                            e.preventDefault();
                            e.stopPropagation();
                            closeDropdown(toggle, dropdownItem, dropdownMenu);
                            toggle.focus();
                            break;

                        case "ArrowDown":
                            e.preventDefault();
                            if (index < menuLinks.length - 1) {
                                menuLinks[index + 1].focus();
                            } else {
                                menuLinks[0].focus();
                            }
                            break;

                        case "ArrowUp":
                            e.preventDefault();
                            if (index > 0) {
                                menuLinks[index - 1].focus();
                            } else {
                                menuLinks[menuLinks.length - 1].focus();
                            }
                            break;
                    }
                });
            });
        }

        /** ---------------------------
            *  CLOSE WHEN CLICKING OUTSIDE
            * --------------------------- */
        document.addEventListener("click", (e) => {
            if (!dropdownItem.contains(e.target)) {
                closeDropdown(toggle, dropdownItem, dropdownMenu);
            }
        });
    });

    /** ---------------------------
        *  UTILITY FUNCTIONS
        * --------------------------- */
    function openDropdown(toggle, item, menu) {
        // Close all other open dropdowns
        document.querySelectorAll(".nav-item.dropdown.show, .nav-item.has-megamenu.show").forEach((otherItem) => {
            if (otherItem !== item) {
                const otherToggle = otherItem.querySelector(".dropdown-toggle");
                const otherMenu = otherItem.querySelector(".dropdown-menu");
                closeDropdown(otherToggle, otherItem, otherMenu);
            }
        });

        toggle.setAttribute("aria-expanded", "true");
        item.classList.add("show");
        if (menu) menu.classList.add("show");
    }

    function closeDropdown(toggle, item, menu) {
        toggle.setAttribute("aria-expanded", "false");
        item.classList.remove("show");
        if (menu) menu.classList.remove("show");
    }

    function toggleDropdown(toggle, item, menu) {
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        if (isExpanded) {
            closeDropdown(toggle, item, menu);
        } else {
            openDropdown(toggle, item, menu);
        }
    }
});